import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBusinesses(ctx, params) {
      const queryParams = {
        businessID: 1,
        pageNumber: params.pageNumber || 1,
        pageSize: params.perSize || 10,
        search: params.search || '',
      };

      return new Promise((resolve, reject) => {
        api
          .get('/Business/GetByPagination', { params: queryParams })
          .then((response) => {
            resolve({
              businesses: response.data.data.results,
              totalCount: response.data.data.totalCount,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchBusinessDetails(ctx) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/Business/GetAllWithCount?businessID=${businessID}`)
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              if (
                'data' in response.data &&
                'results' in response.data.data &&
                Array.isArray(response.data.data.results)
              ) {
                const business = response.data.data.results.find((b) => b.id === businessID);

                if (business) {
                  resolve(business);
                } else {
                  reject('No business found');
                }
              } else {
                reject('No business found');
              }
            } else {
              console.error('Error occurred ---> :', response.data);
              reject('Error fetching Customer data');
            }
          })
          .catch((error) => {
            console.error('Error occurred ---> :', error);
            reject(error);
          });
      });
    },
    updateBusiness(ctx, businessData) {
      console.log('=== BusinessStoreModule updateBusiness called');
      console.log('=== businessData:', businessData);
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;
      console.log('=== businessID:', businessID);
      console.log('=== userID:', userID);

      const payload = {
        id: businessData.id || businessID,
        businessID: 1,
        name: businessData.name,
        logo: businessData.logo || '',
        address: businessData.address,
        phone: businessData.phone,
        email: businessData.email,
        website: businessData.website,
        province: businessData.province,
        createdDate: businessData.createdDate || new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        isDeleted: businessData.isDeleted || false,
      };
      console.log('payload --->:', payload);
      console.log('UserID --->:', userID);

      return new Promise((resolve, reject) => {
        console.log('=== Making API call to:', `/Business/Save?userID=${userID}`);
        api
          .post(`/Business/Save?userID=${userID}`, payload)
          .then((response) => {
            console.log('=== API response:', response);
            resolve(response);
          })
          .catch((error) => {
            console.error('Edit Error --->:', error);
            reject(error);
          });
      });
    },
  },
};
